<template>
	<div>
		<b-row class="align-items-center" v-if="_gAuth.appCode() != 'banker-app'">
			<b-col cols="12" md="12" class="mt-3 d-flex flex-wrap align-items-center">
				<el-button type="warning" plain @click="emitEvent('show-create-chat-group')">
					<i class="fa fa-users"></i>
					Create new group
				</el-button>
				<el-button type="info" plain @click="emitEvent('show-create-private-chat')">
					<i class="fa fa-user"></i>
					Create Private Chat
				</el-button>
				<el-button type="success" plain @click="startOwnMessage()">
					<i class="fa fa-comment-dots"></i>
					Own Message
				</el-button>
				<el-button type="danger" plain @click="openInNewTab()" class="d-none">
					<i class="fa fa-comment-dots"></i>
					Open New Tab
				</el-button>
			</b-col>
		</b-row>
		<b-row class="mt-3">
			<b-col cols="12" v-if="!_gHlp.isEmpty(available_group_chat_list)">
				<div v-for="(group, index) in available_group_chat_list" :key="index">
					<div :class="`border rounded p-3 mb-3 ` + group_class(group)">
						<b-row>
							<b-col cols="12" class="mb-2">
								<div class="d-flex align-items-center justify-content-between">
									<h3 class="font-weight-600 cursor-pointer" @click="emitEvent('show-chats-room', group)">
										<div class="d-flex align-items-center justify-content-start">
											<el-popover placement="right-end" trigger="hover">
												<p>
													<strong>{{ (group.group_channel_type == 'PUBLIC') ? 'Group Message' : 'Private Message'
														}}</strong>
													<small class="d-block">
														Created By {{ getGroupCreator(group) }} at {{ group.group_created_date |
															dateTimeDynamicFormat('DD/MM/YYYY h:mm A') }}
													</small>
												</p>
												<el-button slot="reference" type="success" icon="fa fa-comment-dots" size="mini" plain round
													v-if="(groupIsOwnChat(group))"></el-button>
												<el-button slot="reference" type="warning" icon="fa fa-users" size="mini" plain round
													v-else-if="(group.group_channel_type == 'PUBLIC')"></el-button>
												<el-button slot="reference" type="info" icon="fa fa-user" size="mini" plain round
													v-else></el-button>
											</el-popover>
											<span class="mx-2">{{ getGroupName(group) }}</span>
											<small class="badge badge-xs badge-pill badge-info" v-if="group.group_type == 'external'">external</small>
										</div>
									</h3>
									<!-- <p class="mb-0 text-muted" v-if="group.group_latest_messages">{{ group.group_latest_messages.message_created_date | dateFormatFromNow }}</p> -->
									<div>
										<span v-if="group.group_latest_messages">{{ group.group_latest_messages.message_created_date |
											dateTimeDynamicFormat('DD/MM/YYYY h:mm A') }}</span>
										<el-tooltip :content="'Group Setting'"
											v-if="allow_setting(group) && (group.group_channel_type == 'PUBLIC')">
											<el-button type="default" icon="el-icon-setting" size="mini" class="ml-2" circle
												@click.native.stop="editGroup(group)"></el-button>
										</el-tooltip>
										<el-tooltip :content="'Exit Group'"
											v-if="!allow_setting(group) && userInGroup(group) && (group.group_channel_type == 'PUBLIC')">
											<el-button type="danger" icon="el-icon-delete-solid" size="mini" class="ml-2" circle
												@click.native.stop="exitGroup(group)"></el-button>
										</el-tooltip>
									</div>
								</div>
							</b-col>
							<b-col cols="12" class="mb-2">
								<b-row @click="emitEvent('show-chats-room', group)" class="cursor-pointer messenger-header">
									<b-col cols="auto" class="pr-1">
										<!-- <b-avatar variant="primary" class="mr-2" :src="group.group_latest_messages.message_participant.participant_photo_profile" :text="_gHlp.formatInitials(group.group_latest_messages.message_participant.participant_fullname)"></b-avatar> -->
										<b-avatar variant="primary"
											:class="(_gHlp.isEmpty(group.group_latest_messages)) ? 'no-message' : ''" :src="'#'"
											:text="getUserLastMessage(group)"></b-avatar>
									</b-col>
									<b-col cols="9" md="10" class="pl-1">
										<b-row v-if="group.group_latest_messages">
											<b-col cols="12" class="d-flex align-items-center name">
												<p class="mb-0 font-weight-500 mr-1">{{
													group.group_latest_messages.message_participant.participant_fullname }}</p>
												<!-- <b-badge>Banker</b-badge> -->
											</b-col>
											<b-col cols="12" class="message chat-preview"
												v-html="group.group_latest_messages.message_content">
											</b-col>
										</b-row>
										<b-row v-else>
											<b-col cols="12" class="d-flex align-items-center name">
												<p class="mb-0 font-weight-500 mr-1">No Message</p>
												<!-- <b-badge>Banker</b-badge> -->
											</b-col>
											<b-col cols="12" class="message chat-preview">
												<i>This group does not have a last message</i>
											</b-col>
										</b-row>
									</b-col>
								</b-row>
							</b-col>
							<b-col cols="12">
								<div class="d-flex align-items-center justify-content-between members">
									<el-popover placement="right-end" trigger="hover" v-if="!groupIsOwnChat(group)">
										<p>
											<strong>Member of group</strong>
										<ul class="pl-3">
											<li v-for="(participant, index) in group.group_participants" :key="index">{{
												participant.participant_fullname }}</li>
										</ul>
										</p>
										<p slot="reference" class="d-flex align-items-center">
											<b-avatar-group size="20px">
												<b-avatar v-for="(participant, index) in sliceParticipant(group)" :key="index"
													:text="_gHlp.formatInitials(participant.participant_fullname, 2)"></b-avatar>
											</b-avatar-group>
											<span class="ml-2" v-if="group.group_participants.length > 5"> +{{ group.group_participants.length
												- sliceParticipant(group).length }} Member</span>
										</p>
									</el-popover>
									<div v-else>
										<small><i>Own Message</i></small>
									</div>
									<div>
										<b-badge variant="danger" v-if="group.group_summary.total_unread_messages > 0">New {{
											group.group_summary.total_unread_messages }} Messages</b-badge>
										<span class="font-weight-400 text-muted ml-2">View {{ group.group_summary.total_messages }}
											Messages</span>
									</div>
								</div>
							</b-col>
						</b-row>
					</div>
				</div>
			</b-col>
			<b-col cols="12" v-else>
				<p class="text-muted text-center" @click="emitEvent('show-chats-room', group)">There are no messages in this
					conversation. Start a conversation by sending a message to get the discussion going.</p>
			</b-col>
		</b-row>
		<!-- Drawer for Search Message -->
		<search-message-drawer ref="search_message_drawer"></search-message-drawer>
	</div>
</template>
<script>
import chatEventBus from '@/assets/js/EventBus/chatEventBus.js'
import SearchMessageDrawer from '@/views/Messaging/SearchMessageDrawer'
import { Tooltip, Tag, Dropdown, DropdownItem, DropdownMenu, Popover, Table, TableColumn, Button } from 'element-ui'
import { mapState, mapActions } from 'pinia'
import { useMessagingStore } from '@/stores/messagingStore'
import { useAuthStore } from '@/stores/authStore'
import { useConfigStore } from '@/stores/configStore'
import { swal } from '@/assets/js/httpImports.js'

export default {
	props: {
		showCreatNewGroup: Boolean,
		showMainPage: Boolean,
		showChatRooms: Boolean,
	},
	components: {
		SearchMessageDrawer,
		[Popover.name]: Popover,
		[Tag.name]: Tag,
		[Button.name]: Button,
		[Tooltip.name]: Tooltip,
		[Dropdown.name]: Dropdown,
		[DropdownMenu.name]: DropdownMenu,
		[DropdownItem.name]: DropdownItem,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn
	},
	data() {
		return {
			haveGeneralConversation: false
		}
	},
	computed: {
		...mapState(useMessagingStore, ['available_group_chat_list', 'group_message_list', 'message_profile', 'selected_group']),
		...mapState(useAuthStore, ['auth_user']),
		...mapState(useConfigStore, ['app_code']),
	},
	methods: {
		...mapActions(useMessagingStore, ['getMessages', 'getGroupName', 'getGroupCreator', 'groupIsOwnChat','refreshMessageBox', 'setSelectedGroup', 'getGroupMessageList', 'getGroupMessageDetail', 'updateLoadingMessage', 'updateGroupMessage', 'createInfoMessage', 'getNewBundleKey', 'createGroupMessage']),
		group_class(group) {
			let cls = 'border-public'
			if (group.group_channel_type == 'PRIVATE') {
				cls = 'border-private'
				if (this.groupIsOwnChat(group)) {
					cls = 'border-success'
				}
			}
			return cls
		},
		sliceParticipant(group) {
			if (group.group_participants.length > 5) {
				return group.group_participants.slice(0, 4);
			} else {
				return group.group_participants;
			}
		},
		allow_setting(group) {
			const selectedAdminIds = (!_gHlp.isEmpty(group.group_participants)) ? group.group_participants.filter(x => x.gmp_is_admin == 1).map(o => o.participant_user_id) : []
			return ((group.group_created_by == _gAuth.activeUserId()) || selectedAdminIds.includes(_gAuth.activeUserId()) || _gAuth.isCorporateOwner())
		},
		getUserLastMessage(group) {
			if (!_gHlp.isEmpty(group.group_latest_messages)) {
				return _gHlp.formatInitials(group.group_latest_messages.message_participant.participant_fullname)
			} else {
				return '#'
			}
		},
		userInGroup(group) {
			const activeUserId = _gAuth.activeUserId();
			let exist = group.group_participants.find(o => o.participant_user_id == activeUserId)
			return (!_gHlp.isEmpty(exist))
		},
		emitEvent(eventName, group) {
			if (eventName != 'show-chats-room') {
				chatEventBus.$emit(eventName)
			}else{
				this.getGroupMessageDetail(group.group_id).then(resp => {
					this.getMessages(resp.group_id)
					this.refreshMessageBox(this.message_profile.message_group_bundle_key)
					chatEventBus.$emit(eventName)
				}).catch(err => {
				return;
				})
			}
			return;
		},
		editGroup(group) {
			this.setSelectedGroup(group)
			chatEventBus.$emit('show-edit-chat-group')
		},
		exitGroup(group) {
			swal.fire({
				title: 'Are you sure to leave this group ?',
				text: "After leaving this group, you can no longer see the group and messages in this group",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Yes, Leave !',
			}).then(async (result) => {
				/* Read more about isConfirmed, isDenied below */
				if (result.isConfirmed) {
					this.updateLoadingMessage(true)
					let activeUserId = _gAuth.activeUserId();
					let newParticipants = [];

					group.group_participants.forEach((o) => {
						if (o.participant_user_id != activeUserId) {
							newParticipants.push({
								participant_user_id: o.participant_user_id,
								participant_username: o.participant_username,
								participant_fullname: o.participant_fullname,
								participant_photo_profile: o.participant_photo_profile,
							});
						}
					});

					let updateParams = {
						group_name: group.group_name,
						group_type: group.group_type,
						group_channel_type: group.group_channel_type,
						group_bundle_key: group.group_bundle_key,
						group_participants: newParticipants
					}
					let status = await this.updateGroupMessage(group.group_id, updateParams)
					if (status) {
						this.createInfoMessage('EXIT_GROUP', group.group_id, 0)
						this.getGroupMessageList(this.message_profile.message_group_bundle_key).then(resp => {
							_gNotif.notifySuccess('You Already Exit From Group');
							this.updateLoadingMessage(false)
						});
					}else{
						this.updateLoadingMessage(false)
					}
				}
			})
		},
		async startOwnMessage() {
			const activeUser = _gAuth.activeUser()
			let ownGroupMessage = this.group_message_list.find((item) => {
				return item.group_participants.some((child) => {
					return child.participant_user_id == activeUser.id
				}) && (item.group_channel_type == 'PRIVATE') && (item.group_participants.length == 1)
			}
			);

			if (!_gHlp.isEmpty(ownGroupMessage)) {
				this.emitEvent('show-chats-room', ownGroupMessage)
				return
			}

			let group_participants = [{
				participant_user_id: activeUser.id,
				participant_username: activeUser.name,
				participant_fullname: activeUser.name,
				participant_photo_profile: null,
			}];

			const postData = {
				group_name: activeUser.name + '(You)',
				group_type: 'internal',
				group_channel_type: 'PRIVATE',
				group_bundle_key: this.getNewBundleKey(),
				group_participants: group_participants
			}

			let status = await this.createGroupMessage(postData)
			if (status) {
				this.emitEvent('show-chats-room', this.selected_group)
			}
		},
		openInNewTab(){
			let data = JSON.stringify({
				email: _gAuth.activeUser('email'),
				public_code: _gAuth.activeUser('public_code'),
				app_code: _gAuth.appCode(),
				data: {
					profile:this.message_profile,
					bundle_key:	_gHlp.getValue(this.message_profile,'message_group_bundle_key')
				}
			});
			
			let params = _gHlp.generateQueryParams({
				payload: btoa(data),
			})

			let url = '/messaging?'+params;				
			_gHlp.openNewTab(url);
		}
	},
}
</script>